import React from 'react';
import UserProfile from '../modules/UserProfile';

function UserProfilePage(props){
  return (
    <UserProfile {...props}/>
  )
}

export default UserProfilePage;